import { VError } from 'libs/errors';
import { restService } from 'utilities';

import type {
  GetLiquidityHubsInput,
  GetLiquidityHubsOutput,
  GetLiquidityHubsResponse,
} from 'types';
import { formatToLiquidityHub } from 'utilities/formatToLiquidityHub';

export const getLiquidityHubs = async ({
  chainId,
  tokens,
  accountAddress,
}: GetLiquidityHubsInput): Promise<GetLiquidityHubsOutput> => {
  const response = await restService<GetLiquidityHubsResponse>({
    endpoint: '/liquidity-hub/hubs',
    method: 'GET',
    params: {
      chainId,
      accountAddress,
    },
  });
  const payload = response.data;

  if (payload && 'error' in payload) {
    throw new VError({
      type: 'unexpected',
      code: 'somethingWentWrong',
      data: { exception: payload.error },
    });
  }

  if (!payload) {
    throw new VError({ type: 'unexpected', code: 'somethingWentWrong' });
  }

  const liquidityHubs =
    payload.result?.reduce<GetLiquidityHubsOutput['liquidityHubs']>((acc, apiLiquidityHub) => {
      const liquidityHub = formatToLiquidityHub({ apiLiquidityHub, tokens });

      if (liquidityHub) {
        acc.push(liquidityHub);
      }

      return acc;
    }, []) ?? [];

  return {
    liquidityHubs,
  };
};

export type {
  GetLiquidityHubsInput,
  GetLiquidityHubsOutput,
} from 'types';
